<template>
	<div class="footer">
		<hr/>
		<p>
			<Logo/> is a media-first gallery for Reddit. User content is owned by the submitting user. <Logo/> is not endorsed, sponsored, or supported in any way by Reddit Inc. <router-link :to='{name: "Acknowledgements"}'>Acknowledgements</router-link>. Site version v{{appVersion}}
		</p>
	</div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import settings from '@/utils/settings.js'

export default {
	name: "Footer",
	data() {
		return {
			appVersion: settings.getAppVersion()
		}
	},
	components: {
		Logo
	}
}
</script>

<style scoped>
.footer {
  --separator-color: lightgray;
  --footer-text-color: var(--lighter-main-color);
}

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid var(--separator-color);
    width: 10vw;
    margin: 1em auto;
    padding: 0;
}

p {
	text-align: center;
	color: var(--footer-text-color);
	font-size: 10pt;
}
</style>